import React from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {t, withState} from 'shared/core';
import {Panel, Button, List} from 'components';
import {AdditionalCoverageState} from '../state';
import ApplyCoverageModal from './ApplyCoverageModal';
import DeclineCoverageModal from './DeclineCoverageModal';

const AdditionalCoverage = observer(({uiState}) => {
  const {currentEnrolment, currentEligibilityRecord} = uiState;

  if (!currentEligibilityRecord || currentEligibilityRecord.state !== 'eligible') return null;
  if (!currentEnrolment.effectiveDate) return null;

  return (
    <Panel>
      <Panel.Header
        title={t('components.additional_coverage.Additional Coverage')}
        description={
          t(
            'components.additional_coverage.DESCRIPTION',
            {
              coverageType: t(`models.coverage_types.${currentEligibilityRecord.coverageType}`),
              carrierName: currentEligibilityRecord.companyInsuranceCarrier
            }
          )
        }
      />
      <List items={uiState.currentAdditionalCoverageVolumes}/>
      <div className='clearfix mt3'>
        <Button onClick={() => uiState.openApplyForCoverageModal()} className='mr2'>
          <FormattedMessage id='components.additional_coverage.Apply for Coverage'/>
        </Button>
        <Button onClick={() => uiState.openDeclineCoverageModal()} trait='default'>
          <FormattedMessage id='components.additional_coverage.Decline Coverage'/>
        </Button>
      </div>
      <ApplyCoverageModal uiState={uiState}/>
      <DeclineCoverageModal uiState={uiState}/>
    </Panel>
  );
});

export default withState(AdditionalCoverage, AdditionalCoverageState);
